import { render, staticRenderFns } from "./integralTicketDetails.vue?vue&type=template&id=e507e5a8&scoped=true&"
import script from "./integralTicketDetails.vue?vue&type=script&lang=js&"
export * from "./integralTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./integralTicketDetails.vue?vue&type=style&index=0&id=e507e5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507e5a8",
  null
  
)

export default component.exports